import React, { useState, useEffect, useCallback } from 'react'
import SatsueiDataFormArea from './shared/SatsueiDataFormArea'
import { shareService } from '../services/shareService'

const ShareFormArea = ({ 
  objectId, 
  sharePixId, 
  satsueiMemoCategoryId,
  onSatsueiMemoCategoryChange 
}) => {
  const [satsueiMemoCategoryList, setSatsueiMemoCategoryList] = useState([])
  const [satsueiGuideList, setSatsueiGuideList] = useState([])
  const [objectData, setObjectData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [formData, setFormData] = useState({})

  const loadFormData = useCallback(async () => {
    if (!objectId || !sharePixId) return
    
    setIsLoading(true)
    try {
      // Load satsuei memo category
      const categoryData = await shareService.getSatsueiMemoCategory(false, true, sharePixId)
      setSatsueiMemoCategoryList(categoryData.satsueiMemoCategoryList || [])

      // Load object data
      const objectData = await shareService.getObject(objectId, satsueiMemoCategoryId, true, sharePixId)
      if (objectData.returnCode === '200') {
        setObjectData(objectData)
        
        // Load satsuei guide list
        const guideData = await shareService.getSatsueiGuideList(
          objectData.satsueiMemoCategoryId, 
          true, 
          sharePixId
        )
        setSatsueiGuideList(guideData.satsueiGuideList || [])
      }
    } catch (error) {
      console.error('Failed to load form data:', error)
    } finally {
      setIsLoading(false)
    }
  }, [objectId, sharePixId, satsueiMemoCategoryId])

  useEffect(() => {
    if (objectId && sharePixId) {
      loadFormData()
    }
  }, [objectId, sharePixId, satsueiMemoCategoryId, loadFormData])
  
  const updateFormData = (key, value) => {
    setFormData(prev => ({
      ...prev,
      [key]: value
    }))
  }

  if (isLoading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-center h-48">
          <div className="text-gray-500 text-sm">読み込み中...</div>
        </div>
      </div>
    )
  }

  if (!objectData) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-center h-48 text-gray-500 text-sm">
          データがありません
        </div>
      </div>
    )
  }

  return (
    <SatsueiDataFormArea
      mode="share"
      satsueiMemoForm={null}
      formData={formData}
      updateFormData={updateFormData}
      satsueiMemoCategories={satsueiMemoCategoryList}
      satsueiMemoCategoryId={satsueiMemoCategoryId}
      onCategoryChange={onSatsueiMemoCategoryChange}
      kyotenList={[]}
      kyotenId=""
      setKyotenId={() => {}}
      createUserName={objectData.createUserName}
      createDatetime={objectData.createDatetime}
      updateUserName={objectData.updateUserName}
      updateDatetime={objectData.updateDatetime}
      hasData={!!objectData}
      objectData={objectData}
      satsueiMemoColumnDataList={objectData.satsueiMemoColumnDataList || []}
      satsueiGuideList={satsueiGuideList}
      satsueiGuideId={objectData.satsueiGuideId}
      setSatsueiGuideId={() => {}}
    />
  )
}

export default ShareFormArea